/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Box,
  TextField,
  Drawer,
  Card,
  CardContent,
  // CardActions,
  CardHeader,
  IconButton,
  Autocomplete,
  InputAdornment
} from '@mui/material';
import DatePicker from 'react-datepicker';
import dateFormat from 'dateformat';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import DashboardAction from '../../store/actions/DashboardAction';

function FilterDropdown({
  openmodal,
  onCloseModal,
  setCurrencies,
  currencies,
  setDepartment,
  department,
  setClient,
  client,
  setDateRange,
  startDate,
  endDate,
  handleSubmit
}) {
  // const [drawerOpen, setDrawerOpen] = useState(false);
  const dispatch = useDispatch();

  const { filterData } = useSelector((state) => state.dashboard);
  const { clients, currency, departments } = filterData;
  console.log('🚀 ~ clients:', clients);

  useEffect(() => {
    dispatch(DashboardAction.getFilterOptions());
  }, [dispatch]);

  // const handleSubmit = () => {
  //   dispatch(DashboardAction.getAll(clientId, departmentId, currencyId));
  // };

  const handleReset = () => {
    setClient(null);
    setDepartment(null);
    setCurrencies(null);
    setDateRange([null, null]);
    dispatch(DashboardAction.getAll());
    // onCloseModal();
  };

  const handleRangePicker = (date) => {
    if (!date || date.length !== 2 || date[1] === null) {
      return;
    }
    const formatDate = (newdate) => {
      return dateFormat(newdate, 'yyyy-mm-dd');
    };
    setDateRange(date.map(formatDate));
  };

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={openmodal}
      sx={{
        flexShrink: 0,
        zIndex: '1205 !important'
      }}
    >
      <Box>
        <Card>
          <CardHeader
            sx={{ textAlign: 'left !important' }}
            title="Filters"
            action={
              <IconButton
                aria-label="settings"
                onClick={() => {
                  onCloseModal();
                }}
              >
                <Close />
              </IconButton>
            }
          />
          <CardContent>
            <Autocomplete
              className="CurrencyField"
              value={client}
              options={clients ?? []}
              onChange={(e, newvalue) => {
                setClient(newvalue);
              }}
              getOptionLabel={(option) => option.name}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option._id}>
                    {option.name}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Client"
                  placeholder="Search Client"
                  variant="outlined"
                  margin="normal"
                />
              )}
            />
            <Autocomplete
              className="CurrencyField"
              value={currencies}
              options={currency ?? []}
              onChange={(e, newvalue) => {
                setCurrencies(newvalue);
              }}
              getOptionLabel={(option) => option.name}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option._id}>
                    {option.name}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Currency"
                  placeholder="Search Currency"
                  variant="outlined"
                  margin="normal"
                />
              )}
            />
            <Autocomplete
              className="CurrencyField"
              options={departments ?? []}
              value={department}
              onChange={(e, newvalue) => {
                setDepartment(newvalue);
              }}
              getOptionLabel={(option) => option.name}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option._id}>
                    {option.name}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Department"
                  placeholder="Search Department"
                  variant="outlined"
                  margin="normal"
                />
              )}
            />
            <Box className="datepicker" sx={{ mt: 2 }}>
              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                  setDateRange(update);
                  handleRangePicker(update);
                }}
                monthsShown={2}
                isClearable
                customInput={
                  <TextField
                    label="Date"
                    fullWidth
                    InputProps={{
                      autoComplete: 'off',
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton aria-label="toggle password visibility" edge="end" disabled>
                            <CalendarMonthIcon sx={{ color: '#fff' }} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                }
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: '20px',
                mt: 6
              }}
            >
              <Button
                type="submit"
                className="save__btn"
                variant="contained"
                color="secondary"
                onClick={() => {
                  handleSubmit();
                  onCloseModal();
                }}
                // fullWidth
                size="medium"
              >
                Submit
              </Button>
              <Button
                type="button"
                className="cancel__btn"
                variant="contained"
                color="info"
                size="medium"
                onClick={() => {
                  handleReset();
                }}
              >
                Reset
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Drawer>
  );
}

FilterDropdown.defaultProps = {
  currencies: null,
  department: null,
  client: null,
  startDate: null,
  endDate: null
};

FilterDropdown.propTypes = {
  openmodal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  setCurrencies: PropTypes.func.isRequired,
  currencies: PropTypes.string,
  setDepartment: PropTypes.func.isRequired,
  department: PropTypes.string,
  setClient: PropTypes.func.isRequired,
  client: PropTypes.string,
  setDateRange: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired
};

export default FilterDropdown;
